import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { routes } from '@app/routes';
import { useDirection } from '@hooks';
import { Trans } from '@libs/i18n';
import { ArrowLeftIcon } from '@phosphor-icons/react';

export const AssessmentPageHeader: FC = observer(() => {
  const navigate = useNavigate();
  const { isRtl } = useDirection();

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        backgroundColor: 'background.paper',
        zIndex: 1,
        width: '100%',
        pt: 1,
        borderBottom: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'row',
        gap: 3,
        alignItems: 'center',
      }}
    >
      <Button
        startIcon={<ArrowLeftIcon size={24} style={{ transform: isRtl ? 'scaleX(-1)' : 'none' }} />}
        onClick={() => navigate(routes.assessmentList())}
        variant="outlined"
        sx={{
          borderRadius: 1,
          px: 1.875,
          paddingInlineStart: 1.25,
          py: 1.5,
          backgroundColor: 'transparent',
          color: 'secondary.main',
          border: '1px none',
          span: {
            m: 0,
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            fontSize: '1rem',
            paddingInlineStart: 1,
          }}
        >
          <Trans i18nKey="assessments.new.back" />
        </Typography>
      </Button>
      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: '0.875rem' }}>
        <Trans i18nKey="assessments.new.title" />
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '0.875rem', color: 'text.tertiary' }}>
        <Trans i18nKey="assessments.new.description" />
      </Typography>
    </Box>
  );
});
